import modalSureSelConfirm from './view/modalSureSelConfirm.html'
import modalCancelSuccess from './view/modalCancelSuccess.html'
import modalSureSelConCtrl from './modalSureSelConCtrl'
import modalCancelSuccessCtrl from './modalCancelSuccessCtrl'
import scanSelectionModalCtrl from './scanSelectionModalCtrl'
import scanSelectionModalPage from './view/scanSelectionModal.html'
import deductionCheckPage from './view/deductionCheck.html'
import noDeductionReasonTemplate from './view/noDeductionReasonTemplate.html'
import noDeductionReasonCtrl from './noDeductionReasonCtrl'
import utils from 'utils'
import angular from 'angular'

export default function deductionCheck($uibModal, httpRequest, logger, modalSelConDetailService, operationService, $timeout, Upload, globalFn, selectManualSolution) {
    return {
        restrict: 'E',
        scope: {
            active: '@',
        },
        template: deductionCheckPage,
        link(scope) {
            if (!operationService.hasPermit('deduction_info') && !operationService.hasPermit('non_deduction_info')) {
                return
            }
            scope.deductFlagDict = [{ enumCode: '1', enumName: '勾选' }, { enumCode: '2', enumName: '取消勾选' }]
            scope.importBtnCollapsed = false
            scope.activeTab = `${scope.active}`
            scope.currentOrgId = JSON.parse(localStorage.user_info).user.currentOrgId
            let post_qryDlBatchInfoSuc = httpRequest.post_qryDlBatchInfoSuc.bind(httpRequest)
            const currentRoutAddress = JSON.parse(sessionStorage.getItem('currentRoutAddress'))
            // 抵扣不抵扣区分参数
            const checkFlag = `${scope.active}`
            // 导入、模板下载接口typecode参数
            let typeCode = ''
            scope.selectedRows = []
            scope.selStatus = 'noSel'
            scope.invType = 'normal'
            scope.$watch('selStatus', (newVal, oldVal) => {
                if (!newVal || newVal === oldVal) {
                    return
                }
                // 已勾选才显示勾选日期
                if (scope.invType === 'normal') {
                    scope.invListLabelConfig.invListLabel[7].isHide = newVal !== 'Selected'
                }
            })
            scope.AccountData = {}
            scope.accountLength = 0
            scope.param = {
                pageNum: null,
                pageSize: null,
                param: {
                    // authStatus: 255,
                    authMaxTime: null,
                    authMinTime: null,
                    authType: null,
                    checkStatus: '0',
                    invoiceMaxDate: '',
                    invoiceMinDate: '',
                    invoiceCode: null,
                    invoiceStatus: null,
                    invoiceType: null,
                    saleName: null,
                    checkMaxTime: utils.getNowDate().now_Date,
                    checkMinTime: utils.getLastMonthFirstLast().firstDayOfPreMonth,
                    managerStatus: '1',
                    checkFlag: checkFlag,
                    taxPeriod: '',
                    invoiceAccountStatus: '',
                    orgIdList: [scope.currentOrgId],
                    isReceived: '',
                    sourceAppId: '', //来源系统编码
                },
            }

            // 获取最大开票日期开始时间
            function getMakeOutInvoiceDate(periodYear, periodMonth) {
                periodYear--
                const isLeap = (periodYear % 4 === 0 && periodYear % 100 === 0) || periodYear % 400 === 0
                let days = isLeap ? 366 : 365
                days = days - 360 + 1
                periodMonth = periodMonth.length > 1 ? periodMonth : `0${periodMonth}`
                days = `0${days}`
                let makeOutInvoiceDate = periodYear + periodMonth + days
                makeOutInvoiceDate = makeOutInvoiceDate > '20170701' ? makeOutInvoiceDate : '20170701'
                makeOutInvoiceDate = `${makeOutInvoiceDate[0] + makeOutInvoiceDate[1] + makeOutInvoiceDate[2] + makeOutInvoiceDate[3]}-${makeOutInvoiceDate[4]}${makeOutInvoiceDate[5]}-${makeOutInvoiceDate[6]}${makeOutInvoiceDate[7]}`
                return makeOutInvoiceDate
            }
            // 设置日期组件时间
            function setDateTime(res) {
                const periodCode = res.data.value.periodCode
                const periodYear = periodCode[0] + periodCode[1] + periodCode[2] + periodCode[3]
                const periodMonth = periodCode[4] + periodCode[5]
                const isLeap = (periodYear % 4 === 0 && periodYear % 100 === 0) || periodYear % 400 === 0
                const monthArr = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
                scope.SelectEndDate = `${periodYear}-${periodMonth}-${monthArr[periodMonth - 1]}`
                if (scope.invType === 'customsPayment') {
                    scope.param.param.billDateStart = `${periodYear}-${periodMonth}-` + '01'
                    scope.param.param.billDateEnd = `${periodYear}-${periodMonth}-${monthArr[periodMonth - 1]}`
                    return
                }
                // scope.param.param.invoiceMinDate = `${periodYear}-${periodMonth}-` + '01'
                scope.param.param.authMinTime = `${periodYear}-${periodMonth}-` + '01'
                scope.beginDate = getMakeOutInvoiceDate(periodYear, periodMonth)
                if (isLeap) {
                    monthArr[1] = 29
                }
                // scope.param.param.invoiceMaxDate = `${periodYear}-${periodMonth}-${monthArr[periodMonth - 1]}`
                scope.param.param.authMaxTime = `${periodYear}-${periodMonth}-${monthArr[periodMonth - 1]}`
                if (scope.selStatus == 'noSel' || scope.selStatus == 'Account') {
                    scope.param.param.checkMinTime = ''
                    scope.param.param.checkMaxTime = ''
                }
                //  else {
                //     scope.param.param.checkMinTime = `${periodYear}-${periodMonth}-` + '01'
                //     scope.param.param.checkMaxTime = `${periodYear}-${periodMonth}-${monthArr[periodMonth - 1]}`
                // }
                scope.defaultBeginDate = `${periodYear}-${periodMonth}-` + '01'
                scope.defaultEndDate = `${periodYear}-${periodMonth}-${monthArr[periodMonth - 1]}`
                // scope.SelectEndDate = new Date()
            }

            // 发票类型过滤
            const typecodeArr = ['ivat_orig_inv_type', 'auth_type', 'ivat_invoice_status', 'check_status', 'deduction_check_type', 'ivat_inv_receive_status', 'drawback_check_type', 'label_auth_type', 'manager_status', 'is_received', 'info_source', 'check_type_status', 'voucher_account_status', 'interface_invoice_status', 'interface_source_system', 'wait_deduction', 'department_no', 'not_deduction_reason', 'ivat_comparison_status', 'ivat_red_lock_flag', 'ivat_source_app_id']
            scope.dictionary = {
                YES_NO: [
                    {
                        enumName: '否',
                        enumCode: '0',
                    },
                    {
                        enumName: '是',
                        enumCode: '1',
                    },
                ],
            }
            httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
                scope.dictData = scope.dictionary = $.extend(scope.dictionary, res.data.value)
            })
            scope.orderMap = {
                sortKey: '',
                sortVal: '',
            }
            //机构树的check配置信息
            scope.config = {
                check: {
                    enable: true, //显示不显示复选框
                    chkboxType: { Y: '', N: '' },
                    chkStyle: 'radio',
                    radioType: 'all',
                },
            }
            function getUserOrgList() {
                let currentOrgId = JSON.parse(localStorage.user_info).user.currentOrgId
                httpRequest.get_getUserOrgList().then((res) => {
                    if (res.data.success) {
                        scope.orgList = res.data.value
                        // 机构勾选变化
                        scope.orgIdListArr = []
                        // 展开节点及全选
                        angular.forEach(scope.orgList, function (item, index) {
                            item.open = false
                            // 默认勾选当前机构
                            if (item.orgId === currentOrgId) {
                                item.checked = true
                                scope.orgIdListArr.push(item.orgId)
                                // 默认显示当前机构
                                scope.selectedOrgList = [item]
                                scope.menuPermissions(item.orgId)
                            }
                        })
                        scope.param.param.orgIdList = scope.orgIdListArr
                        // 返回机构名称
                        scope.fliterOrgName = function (id) {
                            if (id === null) {
                                return id
                            }
                            if (res.data.value === null) {
                                return id
                            }
                            const fliterUkeyNameArr = res.data.value.filter((item) => item.orgId === id)
                            if (fliterUkeyNameArr.length > 0) {
                                return fliterUkeyNameArr[0].orgName
                            }
                            return id
                        }
                    }
                })
                getCheckInvoiceStatics()
            }
            function getCheckInvoiceStatics() {
                if (scope.activeTab == 1) {
                    // 获取抵扣统计
                    httpRequest.post_getCheckInvoiceStatics(scope.param.param).then((res) => {
                        const { adValoremTotal, invoiceNum, totalAmt, totalTaxamt } = res.data.value
                        scope.InterfaceTotal = res.data.value
                        scope.totalAmountTax = scope.InterfaceTotal
                    })
                }
            }
            //  抵扣合计
            scope.$watchCollection('selectedRows', function (newSelectList, oldSelectList) {
                console.log(oldSelectList)
                console.log(newSelectList)
                if (!newSelectList.length && !oldSelectList.length) return
                if (newSelectList.length) {
                    let selectListTotal = {
                        adValoremTotal: 0,
                        invoiceNum: newSelectList.length,
                        totalAmt: 0,
                        totalTaxamt: 0,
                    }
                    angular.forEach(newSelectList, (item, index) => {
                        selectListTotal.totalAmt = globalFn.Add(selectListTotal.totalAmt, item.totalAmt)
                        selectListTotal.adValoremTotal = globalFn.Add(selectListTotal.adValoremTotal, item.adValoremTotal)
                        selectListTotal.totalTaxamt = globalFn.Add(selectListTotal.totalTaxamt, item.totalTaxamt)
                    })
                    console.log(selectListTotal)
                    scope.totalAmountTax = selectListTotal
                }
                if (oldSelectList.length && !newSelectList.length) {
                    console.log(scope.InterfaceTotal)
                    scope.totalAmountTax = scope.InterfaceTotal
                }
            })
            // 获取当前登陆用户的菜单权限
            scope.menuPermissions = function (currentOrgId) {
                httpRequest.post_getFunctionListByUserAndOrgIds([currentOrgId]).then((res) => {
                    scope.allMenuPermissions = res.data.value
                })
            }
            // 权限控制
            scope.hasPermitHandle = function (currentOrgId, hasPermit) {
                // 默认 false
                scope.hasPermitFlag = false
                if (!scope.allMenuPermissions || scope.allMenuPermissions.length == 0) {
                    return scope.hasPermitFlag
                }
                // 对应菜单数据权限
                scope.CurrMenuPermiss = scope.allMenuPermissions.filter((item) => {
                    return item.orgId == currentOrgId
                })
                functionListChild(scope.CurrMenuPermiss[0].functionList, currentRoutAddress, hasPermit, (item, currentRout, hasPermit) => {
                    if (item.url == currentRout) {
                        // console.log('存在路由')
                        return true
                    } else if (item.functionCode == hasPermit) {
                        // console.log('存在对应权限')
                        scope.hasPermitFlag = true
                        return false
                    }
                    return false
                })
                return scope.hasPermitFlag
            }
            // 校验是否有权限
            let functionListChild = function (functionList, currentRout, hasPermit, cb) {
                for (const i in functionList) {
                    let flat = cb(functionList[i], currentRout, hasPermit)
                    if (functionList[i].childFuncList && flat) {
                        functionListChild(functionList[i].childFuncList, currentRout, hasPermit, cb)
                    }
                }
            }
            getUserOrgList()
            //获取所属大区 获取地区时两个参数都不传，获取管理城市时事业部和地区两个都要传
            httpRequest.get_getBelleRegion().then((res) => {
                scope.belleRegionList = res.data.value
            })
            // 获取主管税局所在省市
            httpRequest.get_getAllTaxBureau(localStorage.getItem('id_token')).then((res) => {
                scope.dictDataProvince = res.data.value
            })
            // 获取管理城市时 事业部和地区两个都要传
            scope.$watch('param.param.regionName', function (newVal, oldVal) {
                //重置
                if (!newVal) {
                    scope.belleRegionCityList = []
                    return
                }
                angular.forEach(scope.dictData.department_no, function (item, index) {
                    if (item.enumName === scope.param.param.departmentNo) {
                        scope.departmentNo = item.enumCode
                    }
                })
                angular.forEach(scope.belleRegionList, function (item, index) {
                    if (item.regionName === newVal) {
                        scope.regionNo = item.treeLevelCode
                    }
                })
                let params = {
                    affiliation: scope.departmentNo,
                    regionNo: scope.regionNo,
                }
                if (params.affiliation == '' || params.regionNo == '') return
                httpRequest.get_getBelleRegion(params).then((res) => {
                    scope.belleRegionCityList = res.data.value
                })
            })
            // 所选择的机构名称
            scope.handleOrgChange = function (orgData) {
                scope.orgIdListArr.length = 0
                scope.currentOrgId = orgData[0].orgId
                if (orgData.length > 0) {
                    angular.forEach(orgData, function (item, index) {
                        scope.orgIdListArr.push(item.orgId)
                        getQryOrgTaxPeriod(item.orgId)
                        // 切换机构 切换权限
                        scope.currentOrgId = item.orgId
                        scope.menuPermissions(scope.currentOrgId)
                    })
                    scope.param.param.orgIdList = scope.orgIdListArr
                } else {
                    scope.orgIdListArr = []
                    scope.param.param.orgIdList = scope.orgIdListArr
                }
                getAmt()
                getCheckInvoiceStatics()
            }
            // 未勾选|已勾选tab
            scope.tabChange = function tabChange(v) {
                scope.selStatus = v

                if (scope.selStatus == 'noSel' || scope.selStatus == 'Account') {
                    if (scope.invType === 'normal') {
                        scope.param.param.checkMinTime = ''
                        scope.param.param.checkMaxTime = ''
                    }
                    scope.param.param.checkStatus = '0'
                    if (scope.selStatus == 'Account') {
                        httpRequest
                            .post_qryAccountOkInvoice({
                                type: scope.invType === 'normal' ? 1 : 2,
                            })
                            .then((res) => {
                                scope.AccountData = res.data.value
                                scope.accountLength = scope.AccountData.invoiceList.length
                            })
                    }
                } else {
                    const periodCode = scope.periodCode
                    const periodYear = periodCode[0] + periodCode[1] + periodCode[2] + periodCode[3]
                    const periodMonth = periodCode[4] + periodCode[5]
                    const isLeap = (periodYear % 4 === 0 && periodYear % 100 === 0) || periodYear % 400 === 0
                    const monthArr = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
                    if (isLeap) {
                        monthArr[1] = 29
                    }
                    if (scope.invType === 'normal') {
                        scope.param.param.checkMaxTime = utils.getNowDate().now_Date
                        scope.param.param.checkMinTime = utils.getLastMonthFirstLast().firstDayOfPreMonth
                        // scope.param.param.checkMinTime = `${periodYear}-${periodMonth}-` + '01'
                        // scope.param.param.checkMaxTime = `${periodYear}-${periodMonth}-${monthArr[periodMonth - 1]}`
                    }
                    scope.selStatus == 'checking' ? (scope.param.param.checkStatus = '88') : (scope.param.param.checkStatus = '10')
                }
                qrySelecInfo()
            }

            scope.reset = function () {
                const checkStatus = scope.param.param.checkStatus
                scope.param =
                    scope.invType === 'normal'
                        ? {
                            pageNum: null,
                            pageSize: null,
                            param: {
                                //   authStatus: 255,
                                authMaxTime: null,
                                authMinTime: null,
                                authType: null,
                                checkStatus,
                                invoiceMaxDate: '',
                                invoiceMinDate: '',
                                invoiceCode: null,
                                invoiceStatus: null,
                                invoiceType: null,
                                saleName: null,
                                checkMaxTime: utils.getNowDate().now_Date,
                                checkMinTime: utils.getLastMonthFirstLast().firstDayOfPreMonth,
                                managerStatus: '1',
                                checkFlag: checkFlag,
                                isReceived: '',
                                sourceAppId: '', //来源系统编码
                            },
                        }
                        : {
                            pageNum: null,
                            pageSize: null,
                            param: {
                                auditResult2: '2',
                                billDateEnd: '',
                                billDateStart: '',
                                billId: '',
                                checkFlag,
                                checkStatus,
                                checkTimeEnd: '',
                                checkTimeStart: '',
                                checkType: '0',
                                managerStatus: '1',
                                isReceived: '',
                                sourceAppId: '', //来源系统编码
                            },
                        }
                scope.param.param.orgIdList = scope.orgIdListArr
                setDateTime(scope.res)

                getQryOrgTaxPeriod(JSON.parse(localStorage.user_info).user.currentOrgId)
                // scope.$broadcast('selectedOrgList', scope.selectedOrgList)
            }

            scope.orderMap = {
                sortKey: '',
                sortVal: '',
            }
            scope.selectedHandle = function selectedHandle() {
                scope.param.orderMap = {}
                if (scope.orderMap.sortKey) scope.param.orderMap[scope.orderMap.sortKey] = scope.orderMap.sortVal
                qrySelecInfo()
            }

            function getAmt() {
                if (scope.invType === 'normal') {
                    httpRequest.get_getHeaderData(checkFlag, scope.currentOrgId).then((res) => {
                        scope.hadAmount = res.data.value.hadAmount
                        scope.hadTaxAmt = res.data.value.hadTaxAmt
                        scope.hadCheckNotConfirmAmt = res.data.value.hadCheckNotConfirmAmt
                        scope.hadCheckNotConfirmTaxAmt = res.data.value.hadCheckNotConfirmTaxAmt
                        scope.notHadCheckAmt = res.data.value.notHadCheckAmt
                        scope.notHadCheckTaxAmt = res.data.value.notHadCheckTaxAmt
                        scope.overTaxPeriod = res.data.value.overTaxPeriod
                    })
                }

                if (scope.invType === 'customsPayment') {
                    httpRequest.get_CP_getHeaderData(checkFlag).then((res) => {
                        scope.hadAmount = res.data.value.hadAmount
                        scope.hadTaxAmt = res.data.value.hadTaxAmt
                        scope.hadCheckNotConfirmAmt = res.data.value.hadCheckNotConfirmAmt
                        scope.hadCheckNotConfirmTaxAmt = res.data.value.hadCheckNotConfirmTaxAmt
                        scope.notHadCheckAmt = res.data.value.notHadCheckAmt
                        scope.notHadCheckTaxAmt = res.data.value.notHadCheckTaxAmt
                        scope.overTaxPeriod = res.data.value.overTaxPeriod
                    })
                }
            }

            // 分页
            scope.totalItems = 0 // 组件初始化设置总页数
            scope.param.pageSize = 10
            scope.param.pageNum = 1
            function qrySelecInfo() {
                if (scope.selStatus == 'Account') {
                    if (!scope.param.param.accountCheckFlag) {
                        scope.param.param.accountCheckFlag = 1
                    }
                } else {
                    if (scope.param.param.accountCheckFlag) {
                        delete scope.param.param.accountCheckFlag
                    }
                }

                if (scope.invType === 'normal') {
                    httpRequest.post_qryInvoiceCheckOfPage(scope.param).then((res) => {
                        if (res.data.success) {
                            scope.selecInfoList = res.data.value.list
                            scope.selectedRows = []
                            // 获取后台分页数据 回写分页组件
                            scope.totalItems = res.data.value.total
                            scope.param.pageNum = ++res.data.value.prePage
                            scope.param.pageSize = res.data.value.pageSize
                            if (scope.selStatus === 'noSel') {
                                scope.selecInfoList.forEach((item) => {
                                    item.effectiveTaxamt = item.totalTaxamt
                                })
                            }
                            if (scope.selStatus === 'Account') {
                                scope.selecInfoList.forEach((item) => {
                                    if (item.invoiceAccountStatus == 1) {
                                        item.selected = true
                                        scope.selectedRows.push(item)
                                    }
                                })
                            }
                        }
                    })
                }
                if (scope.invType === 'customsPayment') {
                    httpRequest.post_qryCheckBillOfPage(scope.param).then((res) => {
                        if (res.data.success) {
                            scope.selecInfoList = res.data.value.list
                            scope.selectedRows = []
                            // 获取后台分页数据 回写分页组件
                            scope.totalItems = res.data.value.total
                            scope.param.pageNum = ++res.data.value.prePage
                            scope.param.pageSize = res.data.value.pageSize
                            if (scope.selStatus === 'noSel') {
                                scope.selecInfoList.forEach((item) => {
                                    item.effectiveTaxamt = item.totalTaxamt
                                })
                            }
                            if (scope.selStatus === 'Account') {
                                scope.selecInfoList.forEach((item) => {
                                    if (item.invoiceAccountStatus == 1) {
                                        item.selected = true
                                    }
                                })
                            }
                        }
                    })
                }
                getAmt()
                getCheckInvoiceStatics()
            }
            scope.pageChanged = () => {
                // 点击页码
                qrySelecInfo()
            }

            function enumCodeExchangeName(arr, code) {
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i]['enumCode'] === '' + code) {
                        return arr[i]['enumName']
                    }
                }
            }

            function selInitParam(checked, isCancel, selectList) {
                const reqArr = selectList ? selectList : scope.selectedRows
                let reqStr = ''
                const checkInvoices = []
                let totalAmt = 0
                let totalTaxamt = 0
                let effectiveTaxamt = 0
                const reqArrLen = reqArr.length
                let selFlag = true
                let invoiceStatusFlag = true
                let managerStatusFlag = true
                let invoiceStatusAbnormalInfo = []
                let managerStatusAbnormalInfo = []
                for (let i = 0; i < reqArr.length; i++) {
                    checkInvoices.push({
                        invoiceId: reqArr[i].invoiceAccountId,
                        effectiveTaxAmt: reqArr[i].effectiveTaxamt,
                        notDeductionReason: reqArr[i].notDeductionReason,
                    })
                    totalAmt += reqArr[i].totalAmt
                    totalTaxamt += reqArr[i].totalTaxamt
                    effectiveTaxamt += +reqArr[i].effectiveTaxamt
                    reqArr[i].invoiceDate = reqArr[i].invoiceDate.substring(0, 10)
                    reqStr += `${reqArr[i].invoiceCode}=${reqArr[i].invoiceNumber}=${reqArr[i].invoiceDate}=${isCancel ? 0 : 1}=${scope.activeTab == '1' ? reqArr[i].effectiveTaxamt : reqArr[i].totalTaxamt};`
                    if (checked == 10 && reqArr[i].checkStatus != 0) {
                        selFlag = false
                    }
                    if (checked == 0 && reqArr[i].checkStatus != 10) selFlag = false
                    // 发票状态
                    if (reqArr[i].invoiceStatus != 0 && reqArr[i].invoiceStatus != 7) {
                        invoiceStatusFlag = false
                        invoiceStatusAbnormalInfo.push({
                            invoiceCode: reqArr[i].invoiceCode,
                            invoiceNumber: reqArr[i].invoiceNumber,
                            enumCode: reqArr[i].invoiceStatus,
                        })
                    }
                    // 管理状态
                    if (reqArr[i].managerStatus == 0) {
                        managerStatusFlag = false
                        managerStatusAbnormalInfo.push({
                            invoiceCode: reqArr[i].invoiceCode,
                            invoiceNumber: reqArr[i].invoiceNumber,
                        })
                    }
                }
                reqStr = reqStr.substring(0, reqStr.length - 1)
                const b = modalSelConDetailService.Base64()
                reqStr = b.encode(reqStr)
                const resolveObj = {
                    reqStr,
                    reqArrLen,
                    totalAmt,
                    totalTaxamt,
                    checked,
                    // idArr,
                    checkInvoices,
                    periodCode: scope.periodCode,
                    checkType: 0,
                    effectiveTaxamt,
                    applyType: scope.activeTab == '1' ? '' : '0',
                }
                const res = {
                    resolveObj,
                    selFlag,
                    invoiceStatusFlag,
                    managerStatusFlag,
                    invoiceStatusAbnormalInfo,
                    managerStatusAbnormalInfo,
                }
                return res
            }

            function selInitParamCP(checked, isCancel, selectList) {
                const reqArr = selectList ? selectList : scope.selectedRows
                let reqStr = ''
                const checkInvoices = []
                let totalTaxamt = 0
                let effectiveTaxamt = 0
                const reqArrLen = reqArr.length
                let selFlag = true
                let invoiceStatusFlag = true
                let managerStatusFlag = true
                let invoiceStatusAbnormalInfo = []
                let managerStatusAbnormalInfo = []
                for (let i = 0; i < reqArr.length; i++) {
                    checkInvoices.push({
                        invoiceId: reqArr[i].billId,
                        effectiveTaxAmt: reqArr[i].effectiveTaxamt,
                        notDeductionReason: reqArr[i].notDeductionReason,
                    })
                    totalTaxamt += reqArr[i].totalTaxamt
                    effectiveTaxamt += +reqArr[i].effectiveTaxamt
                    reqArr[i].billDate = reqArr[i].billDate.substring(0, 10)
                    reqStr += `${reqArr[i].billId}=${reqArr[i].totalTaxamt}=${reqArr[i].effectiveTaxamt}=${isCancel ? 0 : 1}=${reqArr[i].billDate};`
                    if (checked == 10 && reqArr[i].checkStatus != 0) {
                        selFlag = false
                    }
                    if (checked == 0 && reqArr[i].checkStatus != 10) selFlag = false
                    // 管理状态
                    if (reqArr[i].managerStatus != 1) {
                        managerStatusFlag = false
                        managerStatusAbnormalInfo.push({
                            billId: reqArr[i].billId,
                        })
                    }
                }
                reqStr = reqStr.substring(0, reqStr.length - 1)
                const b = modalSelConDetailService.Base64()
                reqStr = b.encode(reqStr)
                const resolveObj = {
                    reqStr,
                    reqArrLen,
                    totalTaxamt,
                    checked,
                    // idArr,
                    checkInvoices,
                    periodCode: scope.periodCode,
                    checkType: 0,
                    effectiveTaxamt,
                    applyType: scope.activeTab == '1' ? '' : '0',
                }
                const res = {
                    resolveObj,
                    selFlag,
                    invoiceStatusFlag,
                    managerStatusFlag,
                    invoiceStatusAbnormalInfo,
                    managerStatusAbnormalInfo,
                }
                return res
            }
            function selInitParamAccount() {
                let list = scope.AccountData.invoiceList
                let reqStr = '',
                    totalTaxamt = 0,
                    checkInvoices = [],
                    effectiveTaxamt = 0
                list.forEach((item) => {
                    if (scope.invType === 'normal') {
                        reqStr += `${item.invoiceCode}=${item.invoiceNumber}=${item.invoiceDate.substring(0, 10)}=1=${item.effectiveTaxamt};`
                        checkInvoices.push({
                            invoiceId: item.invoiceAccountId,
                            effectiveTaxAmt: item.effectiveTaxamt,
                            notDeductionReason: item.notDeductionReason,
                        })
                    } else {
                        reqStr += `${item.billId}=${item.totalTaxamt}=${item.effectiveTaxamt}=1=${item.billDate.substring(0, 10)};`
                        checkInvoices.push({
                            invoiceId: item.billId,
                            effectiveTaxAmt: item.effectiveTaxamt,
                            notDeductionReason: item.notDeductionReason,
                        })
                    }
                    totalTaxamt += item.totalTaxamt
                    effectiveTaxamt += item.effectiveTaxamt
                })
                const resolveObj = {
                    reqStr,
                    reqArrLen: list.length,
                    totalTaxamt,
                    checked: 10,
                    // idArr,
                    checkInvoices,
                    periodCode: scope.periodCode,
                    checkType: 0,
                    effectiveTaxamt,
                    applyType: '',
                    activeTab: 1,
                    invType: scope.invType,
                    selStatus: 'Account',
                }
                return resolveObj
            }
            scope.selectionModal = async function (selectList) {
                let flag = await selectManualSolution.getResult()
                if (!flag) return

                //不抵扣勾选 校验是否有不抵扣原因
                if (!scope.checkDeductionReason(scope.selectedRows) && scope.activeTab == '2') {
                    return logger.logError('所勾选的发票存在<不抵扣原因>为空，请检查。')
                }
                if (scope.selStatus == 'Account') {
                    let resolveObj = selInitParamAccount()
                    $uibModal.open({
                        template: modalSureSelConfirm,
                        controller: modalSureSelConCtrl,
                        backdrop: 'static',
                        openedClass: 'mod-modal mod-modal-md',
                        resolve: {
                            items1() {
                                return resolveObj
                            },
                        },
                        scope,
                    })
                } else {
                    let checkHasPermit = scope.activeTab == '1' ? 'deduction_check' : 'non_deduction_check'
                    if (scope.invType === 'normal' && !scope.hasPermitHandle(scope.currentOrgId, checkHasPermit)) {
                        logger.logError('所选的机构没有抵扣勾选权限，请检查！')
                        return
                    }
                    const res = scope.invType === 'normal' ? selInitParam(10, false, selectList) : selInitParamCP(10, false, selectList)
                    const resolveObj = res.resolveObj
                    const selFlag = res.selFlag
                    const invoiceStatusFlag = res.invoiceStatusFlag
                    const managerStatusFlag = res.managerStatusFlag
                    const invoiceStatusAbnormalInfo = res.invoiceStatusAbnormalInfo
                    const managerStatusAbnormalInfo = res.managerStatusAbnormalInfo
                    resolveObj.activeTab = scope.activeTab
                    resolveObj.invType = scope.invType
                    if (resolveObj.reqArrLen > 0 && selFlag && invoiceStatusFlag && managerStatusFlag) {
                        $uibModal.open({
                            template: modalSureSelConfirm,
                            controller: modalSureSelConCtrl,
                            backdrop: 'static',
                            openedClass: 'mod-modal mod-modal-lg',
                            resolve: {
                                items1() {
                                    return resolveObj
                                },
                            },
                            scope,
                        })
                    } else {
                        let msg = ''
                        if (!resolveObj.reqArrLen) {
                            msg = '请至少选择一条未勾选的发票数据！'
                        }
                        if (!selFlag) {
                            msg = '您选择的发票中包含已勾选的发票，不能重复勾选！'
                        }
                        if (!invoiceStatusFlag) {
                            msg = `${scope.activeTab == '1' ? '' : '不'}抵扣勾选失败，原因如下：<br>`
                            for (let i in invoiceStatusAbnormalInfo) {
                                msg += `发票代码：${invoiceStatusAbnormalInfo[i]['invoiceCode']}  号码：${invoiceStatusAbnormalInfo[i]['invoiceNumber']}    原因：发票状态为${enumCodeExchangeName(scope.dictionary.ivat_invoice_status, invoiceStatusAbnormalInfo[i]['enumCode'])}<br>`
                            }
                        }
                        if (!managerStatusFlag) {
                            if (!msg) {
                                msg = `${scope.activeTab == '1' ? '' : '不'}抵扣勾选失败，原因如下：<br>`
                            }
                            for (let i in managerStatusAbnormalInfo) {
                                if (scope.invType === 'normal') {
                                    msg += `发票代码：${managerStatusAbnormalInfo[i]['invoiceCode']}  号码：${managerStatusAbnormalInfo[i]['invoiceNumber']}    原因：管理状态为非正常<br>`
                                }

                                if (scope.invType === 'customsPayment') {
                                    msg += `缴款书号码：${managerStatusAbnormalInfo[i]['billId']}    原因：管理状态为非正常<br>`
                                }
                            }
                        }

                        msg = `<div class="layer-msg-content">
                                <div class="content-left"><i class="icon iconfont icon-error iconfont-error"></i></div>
                                <div class="content-center">
                                    提示
                                    <div class="message-content">${msg}</div>
                                </div>
                            </div>`
                        layer.open({
                            type: 0,
                            title: false,
                            resize: false,
                            closeBtn: 0,
                            btn: ['确定'],
                            shadeClose: false,
                            skin: 'layer-message-self',
                            content: msg,
                            area: ['540px', ''],
                            yes: function (index, layero) {
                                layer.close(index)
                            },
                        })
                    }
                }
            }
            //校验是否有不抵扣原因
            scope.checkDeductionReason = (selectedRows) => {
                try {
                    selectedRows.forEach((item) => {
                        if (!item.notDeductionReason) {
                            throw new Error('break')
                        }
                    })
                } catch (e) {
                    return false
                }
                return true
            }
            scope.cancelSelModal = async () => {
                let flag = await selectManualSolution.getResult()
                if (!flag) return
                let cancelHasPermit = scope.activeTab == '1' ? 'deduction_check' : 'non_deduction_check'
                if (scope.invType === 'normal' && !scope.hasPermitHandle(scope.currentOrgId, cancelHasPermit)) {
                    logger.logError('所选的机构没有取消勾选权限，请检查！')
                    return
                }
                const res = scope.invType === 'normal' ? selInitParam(0, true) : selInitParamCP(0, true)
                const resolveObj = res.resolveObj
                const selFlag = res.selFlag
                const checkFlag = res.checkFlag
                const authCommitStatusFlag = res.authCommitStatusFlag
                resolveObj.invType = scope.invType
                resolveObj.activeTab = scope.activeTab
                if (resolveObj.reqArrLen > 0 && selFlag) {
                    $uibModal.open({
                        template: modalCancelSuccess,
                        controller: modalCancelSuccessCtrl,
                        backdrop: 'static',
                        // windowClass: "modalSelConDetail",
                        openedClass: 'mod-modal mod-modal-lg',
                        resolve: {
                            items2() {
                                return resolveObj
                            },
                        },
                        scope,
                    })
                } else {
                    let msg = ''
                    if (!resolveObj.reqArrLen) {
                        msg = '请至少选择一条已勾选的发票数据！'
                    }
                    if (!selFlag) {
                        msg = '您选择的发票中包含未勾选的发票，不能重复取消勾选！'
                    }
                    if (checkFlag) {
                        msg = '勾选发票列表中有勾选中的发票，不允许执行勾选！'
                    }
                    if (authCommitStatusFlag) {
                        msg = '勾选发票列表中有已提交的发票，不允许执行勾选！'
                    }
                    logger.logMsg({
                        title: '确认提交',
                        icon: 'error',
                        message: msg,
                    })
                }
            }
            scope.checkeConfig = [
                {
                    enumTypeCode: 'check_status',
                    enumName: '未勾选',
                    enumCode: '0',
                },
                {
                    enumTypeCode: 'check_status',
                    enumName: '已勾选',
                    enumCode: '10',
                },
                {
                    enumTypeCode: 'check_status',
                    enumName: '勾选中',
                    enumCode: '88',
                },
            ]
            scope.queryResult = async function () {
                let flag = await selectManualSolution.getResult()
                if (!flag) return
                utils.loading('请求发送中...')
                httpRequest.post_qryIvatConfig().then((res) => {
                    // 单机版
                    if (res.data.value.diskType == 1) {
                        httpRequest.get_getAuthBatch().then((item) => {
                            if (item.data.value.length == 0) {
                                return logger.logSuccess('暂无需要同步的数据')
                            } else {
                                for (let i = 0; i < item.data.value.length; i++) {
                                    const sidParam = {
                                        TAXNO: item.data.value[i].creditCode,
                                        PASS: res.data.value.diskPassword,
                                        ptPassword: res.data.value.platformPassword,
                                        Version: '',
                                        batchNo: item.data.value[i].batchNo,
                                        BusID: item.data.value[i].opType,
                                    }
                                    const sidParamJson = JSON.stringify(sidParam)
                                    const b = modalSelConDetailService.Base64()
                                    const singleReqBase64 = b.encode(sidParamJson)
                                    $.ajax({
                                        url: res.data.value.serverAddress,
                                        type: 'POST',
                                        data: {
                                            SID: 44030202,
                                            SIDParam: singleReqBase64,
                                        },
                                        dataType: 'jsonp',
                                        timeout: 60000,
                                        success(response) {
                                            response = JSON.stringify(response)
                                            item.data.value[i].data = response
                                            httpRequest.post_getHandleSingle(item.data.value[i]).then((res) => {
                                                if (i === item.data.value.length) {
                                                    utils.loaded()
                                                    qrySelecInfo()
                                                }
                                            })
                                        },
                                    })
                                }
                            }
                        })
                    } else {
                        httpRequest.get_syncByBatchNo().then((res) => {
                            utils.loaded()
                            logger.logSuccess(res.data.value)
                            qrySelecInfo()
                        })
                    }
                })
            }
            scope.effectiveTaxamtClick = function (item) {
                item.editStatus = true
                item.effectiveTaxamtTmp = item.effectiveTaxamt
                setTimeout(() => {
                    $('.form-control-effectiveTaxamt').focus()
                })
            }
            scope.effectiveTaxamtBlur = function (item) {
                item.editStatus = false
                if (item.totalTaxamt == 0) {
                    item.effectiveTaxamt = item.totalTaxamt
                    delete item.effectiveTaxamtTmp
                    return
                }
                if (!(item.effectiveTaxamtTmp > 0 && (item.effectiveTaxamtTmp < item.totalTaxamt || item.effectiveTaxamtTmp == item.totalTaxamt))) {
                    item.effectiveTaxamt = item.totalTaxamt
                    delete item.effectiveTaxamtTmp
                    return
                }
                item.effectiveTaxamt = (+item.effectiveTaxamtTmp).toFixed(2)
                delete item.effectiveTaxamtTmp
            }
            scope.$watch('$parent.activeSel', (newV) => {
                if (newV != 3) {
                    getAmt()
                }
            })

            // 扫码识别
            scope.scanModal = function () {
                $uibModal
                    .open({
                        template: scanSelectionModalPage,
                        controller: scanSelectionModalCtrl,
                        backdrop: 'static',
                        openedClass: 'mod-modal mod-modal-lg modal-reimburse-detail modal-collection-scan',
                        resolve: {
                            items1() {
                                return ''
                            },
                        },
                    })
                    .result.then((selectedList) => {
                        selectedList && selectedList.length && scope.selectionModal(selectedList)
                    })
            }

            // 批量导入
            scope.uploadFiles = async function uploadFiles(file, errFiles) {
                let flag = await selectManualSolution.getResult()
                if (!flag) return

                let hasPermit = scope.activeTab == '1' ? 'import_deduction_check' : 'import_non_deduction_check'
                if (scope.invType === 'normal' && !scope.hasPermitHandle(scope.currentOrgId, hasPermit)) {
                    logger.logError('所选的机构没有导入权限，请检查！')
                    return
                }
                if (file == null && errFiles.length >= 1) {
                    logger.logError('文件类型错误，文件大小不超过5MB，只支持.xlsx,.xls格式文件导入')
                    return
                }
                if (file) {
                    file.upload = Upload.upload({
                        url: `${host.etcloudIvatApp}dl/dlTaskService/importBill`,
                        data: {
                            importFile: file,
                            typeCode,
                        },
                    })
                    // 文件上传
                    // loading动画
                    const importinglayer = layer.msg('玩命上传中，请耐心等待', {
                        time: 0,
                        skin: 'layer-loading-self',
                        icon: 16,
                        shade: 0.5,
                    })
                    file.upload.then(
                        (res) => {
                            $timeout(() => {
                                if (!res.data.success) {
                                    layer.close(importinglayer)
                                    return logger.logError(res.data.message || '上传失败')
                                }
                                if (res.data.value.sourceCount === 0) {
                                    layer.close(importinglayer)
                                    return logger.logTips('导入数据为空！', 'warn')
                                }
                                const { batchNo, sourceCount, errorCount } = res.data.value
                                // 有错误数据，查询错误信息，错误弹框
                                if (res.data.value.errorCount > 0) {
                                    httpRequest
                                        .post_getPageDlBatchInfoListIvat({
                                            pageNum: 1,
                                            pageSize: 10,
                                            param: res.data.value.batchNo,
                                        })
                                        .then((res1) => {
                                            layer.close(importinglayer)
                                            importErrorModal({
                                                batchNo,
                                                sourceCount,
                                                successCount: sourceCount - errorCount,
                                                errorCount,
                                                data: res1.data.value,
                                                data: res1.data.value,
                                                activeTab: scope.activeTab,
                                                invType: scope.invType,
                                            })
                                        })
                                }
                                // 无错误，查询正常发票，确认弹框
                                if (res.data.value.errorCount === 0) {
                                    // if(res.data.value.errorCount > 0) {
                                    post_qryDlBatchInfoSuc({
                                        pageNum: 1,
                                        pageSize: 10,
                                        param: res.data.value.batchNo,
                                    }).then((res1) => {
                                        layer.close(importinglayer)
                                        importConfirmModal({
                                            batchNo,
                                            sourceCount,
                                            successCount: sourceCount - errorCount,
                                            errorCount,
                                            data: res1.data.value,
                                            activeTab: scope.activeTab,
                                            dictData: scope.dictData,
                                            invType: scope.invType,
                                        })
                                    })
                                }
                            })
                        },
                        (response) => {
                            if (response.status > 0) {
                                layer.close(importinglayer)
                                logger.logError('上传失败')
                            }
                        }
                    )
                }
            }
            // 错误弹框
            const importErrorModal = function importErrorModal(modalData) {
                const modalInstance = $uibModal.open({
                    templateUrl: 'importError.html',
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        'logger',
                        'items1',
                        function ($scope, $uibModalInstance, logger, items1) {
                            $scope.modalData = items1
                            $scope.invType = items1.invType
                            $scope.list = items1.data.list
                            $scope.list.forEach((item) => {
                                $scope.invType === 'normal' ? handleListData(item) : CP_handleListData(item)
                            })
                            $scope.pageOptions = {
                                // 分页器
                                totalItems: $scope.modalData.data.total,
                                currentPage: ++$scope.modalData.data.prePage,
                                maxSize: $scope.modalData.data.pageSize,
                            }
                            function handleListData(data) {
                                let obj = JSON.parse(data.rowContent)
                                data.invoiceCode = obj.invoiceCode
                                data.invoiceNumber = obj.invoiceNumber
                            }
                            function CP_handleListData(data) {
                                let obj = JSON.parse(data.rowContent)
                                data.billId = obj.billId
                            }
                            function queryList() {
                                httpRequest
                                    .post_getPageDlBatchInfoListIvat({
                                        pageNum: $scope.pageOptions.currentPage,
                                        pageSize: $scope.pageOptions.maxSize,
                                        param: $scope.modalData.batchNo,
                                    })
                                    .then((res) => {
                                        $scope.list = res.data.value.list
                                        $scope.list.forEach((item) => {
                                            $scope.invType === 'normal' ? handleListData(item) : CP_handleListData(item)
                                        })
                                        $scope.pageOptions = {
                                            // 分页器
                                            totalItems: res.data.value.total,
                                            currentPage: ++res.data.value.prePage,
                                            maxSize: res.data.value.pageSize,
                                        }
                                    })
                            }

                            $scope.pageChanged = () => {
                                queryList()
                            }
                            $scope.ok = () => {
                                $uibModalInstance.close()
                            }
                        },
                    ],
                    backdrop: 'static',
                    openedClass: 'mod-modal-importexcel',
                    windowClass: 'mod-modal mod-modal-lg',
                    bindToController: true,
                    resolve: {
                        items1() {
                            return modalData
                        },
                    },
                })
                modalInstance.result.then(
                    () => { },
                    () => { }
                )
            }
            // 确认弹框
            const importConfirmModal = function importConfirmModal(modalData) {
                const modalInstance = $uibModal.open({
                    templateUrl: 'importConfirm.html',
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        'logger',
                        'items1',
                        function ($scope, $uibModalInstance, logger, items1) {
                            $scope.modalData = items1
                            $scope.dictData = items1.dictData
                            $scope.list = items1.data.list
                            $scope.invType = items1.invType
                            $scope.pageOptions = {
                                // 分页器
                                totalItems: $scope.modalData.data.total,
                                currentPage: ++$scope.modalData.data.prePage,
                                maxSize: $scope.modalData.data.pageSize,
                            }

                            function queryList() {
                                post_qryDlBatchInfoSuc({
                                    pageNum: $scope.pageOptions.currentPage,
                                    pageSize: $scope.pageOptions.maxSize,
                                    param: $scope.modalData.batchNo,
                                }).then((res) => {
                                    $scope.list = res.data.value.list
                                    $scope.pageOptions = {
                                        // 分页器
                                        totalItems: res.data.value.total,
                                        currentPage: ++res.data.value.prePage,
                                        maxSize: res.data.value.pageSize,
                                    }
                                })
                            }

                            $scope.pageChanged = () => {
                                queryList()
                            }

                            let allList = []

                            function getAllList(pageNum, pageSize, param, qryLoading) {
                                post_qryDlBatchInfoSuc({
                                    pageNum,
                                    pageSize,
                                    param,
                                }).then(
                                    (res) => {
                                        allList = allList.concat(res.data.value.list)
                                        if (allList.length != res.data.value.total) {
                                            getAllList(pageNum + 1, pageSize, param, qryLoading)
                                        } else {
                                            $uibModalInstance.close(allList, qryLoading)
                                        }
                                    },
                                    () => {
                                        logger.logError('查询数据出错')
                                    }
                                )
                            }
                            $scope.ok = () => {
                                const qryLoading = layer.msg('正在处理，请您耐心等待···', {
                                    time: 0,
                                    skin: 'layer-loading-self',
                                    icon: 16,
                                    shade: 0.5,
                                })
                                getAllList(1, 20, $scope.modalData.batchNo, qryLoading)
                                // $uibModalInstance.close()
                            }
                            $scope.cancel = () => {
                                $uibModalInstance.dismiss()
                            }
                        },
                    ],
                    backdrop: 'static',
                    openedClass: 'mod-modal-importexcel',
                    windowClass: 'mod-modal modal-deduction-import-confirm',
                    bindToController: true,
                    resolve: {
                        items1() {
                            return modalData
                        },
                    },
                })
                modalInstance.result.then(
                    (allList, qryLoading) => {
                        // 勾选
                        layer.close(qryLoading ? qryLoading : layer.index)
                        allList && allList.length && scope.selectionModal(allList)
                    },
                    () => { }
                )
            }
            // 模板下载
            scope.downloadExcel = function downloadExcel() {
                window.open(`${host.etcloudIvatApp}dl/dlTaskService/export_${typeCode}?accessToken=${localStorage.getItem('id_token')}`)
            }

            // 发票种类切换
            scope.invTypeChange = function (v) {
                scope.invType = v
                getAmt()
                scope.orderMap = {
                    sortKey: '',
                    sortVal: '',
                }
                post_qryDlBatchInfoSuc = scope.invType === 'normal' ? httpRequest.post_qryDlBatchInfoSuc.bind(httpRequest) : httpRequest.post_qryCustomsDlBatchInfoSuc.bind(httpRequest)
                const checkStatus = scope.param.param.checkStatus
                scope.param =
                    scope.invType === 'normal'
                        ? {
                            pageNum: null,
                            pageSize: null,
                            param: {
                                //   authStatus: 255,
                                authMaxTime: null,
                                authMinTime: null,
                                authType: null,
                                checkStatus,
                                invoiceMaxDate: '',
                                invoiceMinDate: '',
                                invoiceCode: null,
                                invoiceStatus: null,
                                invoiceType: null,
                                saleName: null,
                                checkMaxTime: utils.getNowDate().now_Date,
                                checkMinTime: utils.getLastMonthFirstLast().firstDayOfPreMonth,
                                managerStatus: '1',
                                checkFlag: checkFlag,
                                taxPeriod: '',
                                invoiceAccountStatus: '',
                                isReceived: '',
                                sourceAppId: '', //来源系统编码
                            },
                        }
                        : {
                            pageNum: null,
                            pageSize: null,
                            param: {
                                auditResult2: '2',
                                billDateEnd: '',
                                billDateStart: '',
                                billId: '',
                                checkFlag,
                                checkStatus,
                                checkTimeEnd: '',
                                checkTimeStart: '',
                                checkType: '0',
                                managerStatus: '1',
                                taxPeriod: '',
                                invoiceAccountStatus: '',
                                isReceived: '',
                                sourceAppId: '', //来源系统编码
                            },
                        }

                scope.invType === 'normal' && (scope.profileType = scope.activeTab == '1' ? '14' : '137')
                scope.invType === 'customsPayment' && (scope.profileType = scope.activeTab == '1' ? '142' : '143')

                // 搜索字段,字段设置
                let invListLabelConfigWithoutCheck =
                    scope.invType === 'normal'
                        ? {
                            version: 5.54,
                            invListLabel: [
                                {
                                    label: '开票日期',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '发票代码',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '发票号码',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '销方名称',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '发票状态',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '发票种类',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '管理状态',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '勾选日期', // 已勾选才显示勾选日期
                                    selected: true,
                                    default: true,
                                    isHide: true,
                                },
                                {
                                    label: '对账状态',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '会计期间',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '入账月份',
                                    default: false,
                                    selected: false,
                                },
                                {
                                    label: '归档月份',
                                    default: false,
                                    selected: false,
                                },
                                {
                                    label: '收票状态',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '报销状态',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '关联单据号',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '凭证号',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '来源系统',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '业务单据号',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '待抵扣标志',
                                    default: false,
                                    selected: false,
                                },
                                {
                                    label: '收票人',
                                    default: false,
                                    selected: false,
                                },
                                {
                                    label: '机构名称',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '事业部',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '所属大区',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '管理城市',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '主管税局所在省市',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '状态比对',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '付款日期',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '收票时间',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '数电票号码',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '红字锁定标识',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '企业勾选标识',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '来源系统编码',
                                    selected: false,
                                    default: false,
                                },

                            ],
                            table: [
                                {
                                    label: '对账状态',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '发票代码',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '发票号码',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '开票日期',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '销方名称',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '发票金额',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '发票税额',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '发票状态',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '勾选状态',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '发票种类',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '勾选时间',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    // 11
                                    label: '勾选查询结果',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    // 12
                                    label: '有效税额',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '管理状态',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '信息来源',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '会计期间',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '凭证号',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '入账月份',
                                    default: false,
                                    selected: false,
                                },
                                {
                                    label: '归档月份',
                                    default: false,
                                    selected: false,
                                },
                                {
                                    label: '收票状态',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '报销状态',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '关联单据号',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '来源系统',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '业务单据号',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '待抵扣标志',
                                    default: false,
                                    selected: false,
                                },
                                {
                                    label: '收票人',
                                    default: false,
                                    selected: false,
                                },
                                {
                                    label: '机构名称',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '事业部',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '所属大区',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '管理城市',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '主管税局所在省市',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '状态比对',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '付款日期',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '收票时间',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '数电票号码',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '红字锁定标识',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '企业勾选标识',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '勾选标识日期',
                                    selected: false,
                                    default: false,
                                },
                                {
                                    label: '来源系统编码',
                                    selected: false,
                                    default: false,
                                },
                            ],
                        }
                        : {
                            version: 5.5,
                            invListLabel: [
                                {
                                    label: '缴款书号码',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '填发日期',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '管理状态',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '对账状态',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '会计期间',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '入账月份',
                                    default: false,
                                    selected: false,
                                },
                                {
                                    label: '归档月份',
                                    default: false,
                                    selected: false,
                                },
                                //   {
                                //     label: '数电票号码',
                                //     selected: false,
                                //     default: false,
                                //   },
                            ],
                            table: [
                                {
                                    label: '对账状态',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '缴款书号码',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '填发日期',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '税款金额',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '有效税额',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '信息来源',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '勾选状态',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '勾选时间',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '管理状态',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '会计期间',
                                    selected: true,
                                    default: true,
                                },
                                {
                                    label: '凭证号',
                                    selected: true,
                                    default: true,
                                },
                                //   {
                                //     label: '数电票号码',
                                //     selected: false,
                                //     default: false,
                                //   },
                            ],
                        }

                if (scope.activeTab == '2' && scope.invType === 'normal') {
                    invListLabelConfigWithoutCheck.table.splice(0, 1)
                    invListLabelConfigWithoutCheck.table.splice(10, 1)
                    invListLabelConfigWithoutCheck.table.splice(10, 1)
                    invListLabelConfigWithoutCheck.table.splice(30, 1)
                    let addFields = {
                        label: '不抵扣原因',
                        selected: false,
                        default: false,
                    }

                    invListLabelConfigWithoutCheck.table.push(addFields)
                    invListLabelConfigWithoutCheck.invListLabel.push(addFields)
                    console.log(invListLabelConfigWithoutCheck.table)
                }
                if (scope.activeTab == '2' && scope.invType === 'customsPayment') {
                    invListLabelConfigWithoutCheck.table.splice(0, 1)
                    invListLabelConfigWithoutCheck.table.splice(3, 1)
                    invListLabelConfigWithoutCheck.table.splice(invListLabelConfigWithoutCheck.table.length - 2, 2)
                    invListLabelConfigWithoutCheck.invListLabel.splice(invListLabelConfigWithoutCheck.invListLabel.length - 2, 2)

                    let addFields = {
                        label: '不抵扣原因',
                        selected: true,
                        default: true,
                    }
                    invListLabelConfigWithoutCheck.table.push(addFields)
                    invListLabelConfigWithoutCheck.invListLabel.push(addFields)
                }
                scope.invListLabelConfig = invListLabelConfigWithoutCheck

                getQryOrgTaxPeriod(JSON.parse(localStorage.user_info).user.currentOrgId)
                if (scope.invType === 'normal') {
                    typeCode = scope.activeTab == '1' ? 'DEC_CHECK' : 'NOT_DEC_CHECK'
                }
                if (scope.invType === 'customsPayment') {
                    typeCode = scope.activeTab == '1' ? 'CUSTOMS_DEC_CHECK' : 'CUSTOMS_NOT_DEC_CHECK'
                }
            }
            scope.invTypeChange('normal')
            // 根据机构获取所属期
            function getQryOrgTaxPeriod(orgId) {
                httpRequest.get_qryOrgTaxPeriod(orgId).then((res) => {
                    if (res.data.success) {
                        scope.res = res
                        scope.periodName = res.data.value.periodName
                        scope.expireTime = res.data.value.expireTime
                        scope.periodCode = res.data.value.periodCode
                        const expireTimeArr = scope.expireTime.split('-')
                        scope.expireTime = `${expireTimeArr[0]}年${expireTimeArr[1]}月${expireTimeArr[2]}日`
                        scope.param.param.periodCode = scope.periodCode
                        setDateTime(res)
                        if (scope.invType === 'normal') {
                            scope.param.param.authMinTime = null
                            scope.param.param.authMaxTime = null
                        }
                        getUserOrgList()
                        qrySelecInfo()
                    } else {
                        scope.periodName = ''
                        scope.expireTime = ''
                        scope.param.param.invoiceMinDate = ''
                        scope.param.param.invoiceMaxDate = ''
                    }
                })
            }
            // 导出
            scope.exportExcel = () => {
                let url = `${host.etcloudIvatApp}auth/ivatDeductionCheck/exportCheckInvoiceToExcel`
                utils.post_downLoadExcel(scope.param.param, url)
            }
            //不抵扣原因配置
            scope.noDeductionReasonConfig = {
                btnText: '批量操作',
                options: [
                    {
                        text: '不抵扣原因',
                        hasPermit: 'no_deduction_reason',
                        handler() {
                            scope.noDeductionReason()
                        },
                    },
                ],
            }
            scope.noDeductionReason = () => {
                const list = scope.selectedRows
                if (!list.length) {
                    return logger.logError('请选择至少一条数据再操作！')
                }
                let invoiceAccountIdList = list.map((item) => {
                    return item.invoiceAccountId
                })
                let billIdList = list.map((item) => {
                    return item.billId
                })
                const modalInstance = $uibModal.open({
                    template: noDeductionReasonTemplate,
                    controller: noDeductionReasonCtrl,
                    backdrop: 'static',
                    openedClass: 'mod-modal mod-modal-lg',
                    resolve: {
                        items1() {
                            return { dictData: scope.dictData, invoiceAccountIdList, billIdList }
                        },
                    },
                })
                modalInstance.result.then(
                    (res) => {
                        qrySelecInfo()
                    },
                    () => { }
                )
            }
        },
        controller: [
            '$scope',
            ($scope) => {
                const startDate = new Date()
                startDate.setFullYear(startDate.getFullYear() - 5)
                $scope.datePickerConfig = {
                    startDate,
                    endDate: new Date(),
                    format: 'yyyymm',
                    startView: 'year',
                    minView: 'year',
                }
            },
        ],
    }
}

deductionCheck.$inject = ['$uibModal', 'httpRequest', 'logger', 'modalSelConDetailService', 'operationService', '$timeout', 'Upload', 'globalFn', 'selectManualSolution']



// WEBPACK FOOTER //
// ./src/components/deductionCheck/deductionCheck.js